import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  getKycTrackDetails,
  hideLoader,
  setCurrentStep,
  showLoader,
} from "../../../../store/actions";
import {
  getBankDetails,
  getFundChoices,
  getKycDetails as getKycDetailsSubscriber,
  getNomineeList,
  getPersonalDetails,
  getSchemeDetails,
  saveBasicDetails,
  storeAckNumber,
  storeInvestorDetails,
} from "../../../../store/actions/newSubscriber";
import { getProfileData } from "../../../../store/actions/profile";
import CustomLoader from "../../../forms/Loader";
import { NewSubscriberProvider } from "../Context/NewSubsciberContext";
import NewSubscriberStepper from "./lib/NewSubscriberStepper";
import { SUCCESS_RESPONSE_CODE } from ".";

const NewSubscriber = (props) => {
  const [agentRefNumber, setAgentRefNumber] = useState("");
  const subscriberPAN =
    props?.location?.state && props?.location?.state?.pan
      ? props.location.state.pan
      : "";

  const dispatch = useDispatch();

  const currentStep = useSelector((state) => state.newSubscriber.step);
  const token = useSelector((state) => state.authReducer.token);
  const userId = useSelector((state) => state.authReducer.userId);
  const displayLoader = useSelector((state) => state.loaderUtil.displayLoader);
  const { PAN } = useSelector((state) => state.profileReducer.profileData);

  useEffect(() => {
    const fetchInvestorDetails = async (AckNumber) => {
      const PromiseAllArray = [
        dispatch(getPersonalDetails({ AckNumber })),
        dispatch(getKycDetailsSubscriber({ AckNumber })),
        dispatch(getBankDetails({ AckNumber })),
        dispatch(getNomineeList({ AckNumber })),
        dispatch(getSchemeDetails({ AckNumber })),
        dispatch(getFundChoices()),
      ];
      try {
        dispatch(showLoader());
        await Promise.all(PromiseAllArray);
        dispatch(setCurrentStep(1));
      } catch (error) {
        console.error(error);
        alert(error);
        dispatch(setCurrentStep(1));
      } finally {
        dispatch(hideLoader());
      }
    };
    const addSubscriber = async () => {
      try {
        dispatch(showLoader());
        const investorDetails = await dispatch(
          getKycTrackDetails({ pan: subscriberPAN })
        );
        const { DtData } = investorDetails;
        if (!!DtData && !!DtData.length) {
          const { name1, mobile, email } = DtData[0];
          dispatch(storeInvestorDetails(DtData[0]));
          if (!!name1 && !!mobile && !!email && !!agentRefNumber) {
            const params = {
              ApplicantType: "AL",
              MobileNo: mobile,
              Email: email,
              FullName: name1,
              AgentRefNumber: agentRefNumber,
              MobileEmailRegstredFlag: "M",
            };
            const response = await dispatch(saveBasicDetails(params));
            if (+response.statusCode === SUCCESS_RESPONSE_CODE) {
              await fetchInvestorDetails(response.data);
              dispatch(storeAckNumber(response.data));
            }
          } else {
            dispatch(setCurrentStep(0));
          }
        } else {
          dispatch(setCurrentStep(0));
        }
      } catch (error) {
        console.error(error);
        alert(error);
      } finally {
        dispatch(hideLoader());
      }
    };
    if (!!subscriberPAN) {
      addSubscriber();
    }
  }, [dispatch, subscriberPAN, agentRefNumber]);

  useEffect(() => {
    const fetchDistributorDetails = async () => {
      try {
        dispatch(showLoader());
        await dispatch(
          getProfileData({
            Agent: token,
            UserId: userId,
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        dispatch(hideLoader());
      }
    };

    fetchDistributorDetails();
  }, [dispatch, token, userId]);

  useEffect(() => {
    if (PAN) {
      const arn = token.replace("ARN-", "");
      const diff = 8 - arn.length;
      const pad = "0".repeat(diff);
      setAgentRefNumber(PAN + pad + arn);
    }
  }, [PAN, token]);

  // const popDetails = useEmpanelment(agentRefNumber);
  return (
    <NewSubscriberProvider>
      <CustomLoader display={displayLoader} />
      <div className="digital-form-container-investor-flow ">
        {currentStep !== 8 &&
          props.location.pathname !== "/nps/AddSubs/new-reg" && (
            <div
              className={
                "digital-form-Left-div new-subscriber-responsive-display"
              }
            >
              <NewSubscriberStepper active={currentStep} />
            </div>
          )}
        <div className={"digital-form-Right-div-investor-flow"}>
          {props.children}
          {/* {displayCurrentStep(
            currentStep,
            agentRefNumber,
            subscriberPAN,
            popDetails
          )} */}
        </div>
      </div>
    </NewSubscriberProvider>
  );
};
export default NewSubscriber;
